import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { EditPersonalData } from '@components/molecules/EditPersonalData';

export function EditMyProfile() {
    return (
        <MobileContainer>
            <EditPersonalData />
        </MobileContainer>
    );
}
